import { HeaderColumn } from '@tableau/data-grid-1-wrapper';
import React from 'react';

import { CommonStyles } from '../../styles/CommonStyles';
import { imgUrl } from '../../utils/ImgUrl';

export module SortableHeader {

  /**
   * Produces a header formatter that handles displaying sorted state.
   */
  export function Formatter(): React.Factory<any> {
    return React.createFactory(class extends React.Component<HeaderColumn.HeaderFormatterProps, any> {
      render() {
        const col = this.props.col;
        const isSortable = col.sortable !== false;
        const hCellStyles = {
          ...CommonStyles.Layout.TextEllipsis,
          marginRight: CommonStyles.Sizes.MediumSpace,
          textDecoration: isSortable && this.props.hovered ? 'underline' : 'none',
        };

        return (
          <div style={ hCellStyles }>
            <ArrowIcon sorted={ this.props.sorted } ascending={ this.props.sortAscending }/>
              { col.headerText }
            </div>
        );
      }
    });
  }

  export function ArrowIcon(props: { sorted: boolean, ascending: boolean }) {
    // arrow takes up left padding of hcell
    const arrowWidth = CommonStyles.Sizes.MediumSpace;
    const arrowHeight = CommonStyles.Sizes.NormalIconSize;
    let backgroundUrl: string | undefined = undefined;
    if (props.sorted) {
      backgroundUrl =
        props.ascending ? imgUrl('narrow_sort_arrow_ascending.svg') : imgUrl('narrow_sort_arrow_descending.svg');
    }
    const arrowStyles = {
      width: arrowWidth,
      height: arrowHeight,
      display: 'inline-block',
      verticalAlign: 'middle',
      backgroundPosition: 'center',
      backgroundSize: arrowWidth + 'px ' + arrowHeight + 'px',
      backgroundRepeat: 'no-repeat',
      backgroundImage: backgroundUrl
    };
    return <div style={ arrowStyles } />;
  }

}
